/*
 * Public API Surface of capiche-material
 */

export * from './lib/capiche-material.module';
